import { FC } from 'react';
import { useSelector } from 'react-redux';

import {
  Breadcrumbs,
  Icon,
  Typography,
} from '@beeline/design-system-react/extracted-styles';
import { Icons } from '@beeline/design-tokens/js/iconfont';

import { Link } from 'src/components/Link/Link';
import { labelsByRoute } from 'src/routes/consts';
import { RoutePath } from 'src/routes/types';
import { getNavigationState } from 'src/store/navigation/selectors';

import classes from './Segments.module.scss';

interface BreadcrumbsLinkProps {
  path: RoutePath;
}

const BreadcrumbsLink: FC<BreadcrumbsLinkProps> = ({ path }) => {
  return (
    <div className={classes.linkContainer}>
      <Link key={path} to={`/${path}`}>
        {labelsByRoute[path]}
      </Link>
      <Icon iconName={Icons.NavArrowRight} />
    </div>
  );
};

export const Segments: FC = () => {
  const { segments } = useSelector(getNavigationState);

  const lastIndex = segments.length - 1;

  const prev = segments.slice(0, lastIndex);
  const current = segments[lastIndex];

  return (
    <div className={classes.container}>
      {!!prev.length && (
        <Breadcrumbs>
          {prev.map(path => (
            <BreadcrumbsLink key={path} path={path} />
          ))}
        </Breadcrumbs>
      )}
      <div className={classes.title}>
        <Typography variant='h4'>{labelsByRoute[current]}</Typography>
      </div>
    </div>
  );
};
